import * as React from 'react';
import { PaginationNavigation, SpinnerWrapper } from "soprasteria-ui-library";
import { useAuth } from '../../../App';
import { OrthodonticLkgCfPatientSearchApi } from '../../../api/OrthodonticLkgCfPatientSearchApi';
import { IOrthodonticLkgCfPatient, IOrthodonticLkgCfPatientSearchParams } from '../../../models/IOrthodonticLkgCfPatient';
import { IPagination } from 'soprasteria-ui-library/dist/models/IPagination';
import { useHistory } from 'react-router';
import { OrthodonticLkgCfPatientsSearchForm } from './OrthodonticLkgCfPatientsSearchForm';
import { OrthodonticLkgCfPatientsTable } from './OrthodonticLkgCfPatientsTable';
import { UserContext, isInRole } from '../../../contexts/UserContext';
import { VÅRDANSVARIG } from '../../../utils/RoleConstants';
import { ORTHODONTIC_LKGCF_PATIENTS } from '../../../utils/RouteConstants';

export const OrthodonticLkgCfPatients: React.FunctionComponent<{}> = () => {
    const auth = useAuth();
    const api = new OrthodonticLkgCfPatientSearchApi(auth);
    const [isFetchingOrthodonticLkgCfPatients, setIsFetchingOrthodonticLkgCfPatients] = React.useState<boolean>(false);
    const abortController = new AbortController();
    const [paginationHeader, setPaginationHeader] = React.useState<IPagination>();
    const [orthodonticLkgCfPatients, setOrthodonticLkgCfPatients] = React.useState<IOrthodonticLkgCfPatient[]>();
    const [searchParams, setSearchParams] = React.useState<IOrthodonticLkgCfPatientSearchParams>();
    const [isUmbrellaSearchLoading, setIsUmbrellaSearchLoading] = React.useState<boolean>(false);
    const pageSize = 20;
    const history = useHistory();
    const userInfo = React.useContext(UserContext);
    const hasRoleParaply = isInRole(VÅRDANSVARIG, userInfo.roles ? userInfo.roles : []);

    React.useEffect(() => {
        if (history.location.state !== undefined && history.location.state !== null) {
            searchOrthodonticLkgCfPatients(history.location.state as IOrthodonticLkgCfPatientSearchParams);
        }
        else {
            searchOrthodonticLkgCfPatients({ pageSize: pageSize, pageNumber: 1 });
        }

        return () => {
            abortController.abort();
        }
    }, [])

    const searchOrthodonticLkgCfPatients = (data: IOrthodonticLkgCfPatientSearchParams) => {
        setIsFetchingOrthodonticLkgCfPatients(true);
        data.pageSize = pageSize;
        data.pageNumber = data.pageNumber ?? 1;
        history.push(ORTHODONTIC_LKGCF_PATIENTS, data);

        api.searchOrthodonticLkgCfPatients(data, (response) => {
            setOrthodonticLkgCfPatients(response.data);
            setPaginationHeader(response.paginationHeader);
        }, undefined, () => setIsFetchingOrthodonticLkgCfPatients(false));

        setSearchParams(data);
    }

    const onPageSelect = (pageNumber: number) => {
        if (searchParams) {
            setIsFetchingOrthodonticLkgCfPatients(true);
            var currentSearchParams = searchParams;
            currentSearchParams.pageNumber = pageNumber;
            history.push(ORTHODONTIC_LKGCF_PATIENTS, currentSearchParams);

            api.searchOrthodonticLkgCfPatients(currentSearchParams, (response) => {
                setOrthodonticLkgCfPatients(response.data);
                setPaginationHeader(response.paginationHeader);
            }, undefined, () => setIsFetchingOrthodonticLkgCfPatients(false));
        }
    }

    return (
        <SpinnerWrapper isLoading={isFetchingOrthodonticLkgCfPatients || isUmbrellaSearchLoading}>
            <section className="card">
                <div className="card-header">
                    <h1>Visa registrerade patienter</h1>
                </div>
                <div className="card-body">
                    <OrthodonticLkgCfPatientsSearchForm searchOrthodonticLkgCfPatients={searchOrthodonticLkgCfPatients} preSetSearchParams={history.location.state !== undefined && history.location.state !== null ? history.location.state as any : undefined} isParaply={hasRoleParaply} isLoading={setIsUmbrellaSearchLoading} pageSize={pageSize} />
                    {
                        orthodonticLkgCfPatients ?
                            <>
                                <div className="panel text-right border-top"></div>
                                <OrthodonticLkgCfPatientsTable orthodonticLkgCfPatients={orthodonticLkgCfPatients} />
                                <PaginationNavigation
                                    ariaLabel="received orthodontic lkg cf patients pagination selector"
                                    pagination={paginationHeader}
                                    pageNeighbours={2}
                                    selectedPage={page => onPageSelect(page)}
                                    showCount={true} />
                            </>
                            : null
                    }
                </div>
            </section>
        </SpinnerWrapper>
    )
}